import Service from "../../services";

const state = {};

const getters = {};

const actions = {
  getCategory({ commit }) {
    return Service.categoty
      .getCategory()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
